module.exports = __webpack_public_path__ + "static/media/invitationsSentPopup.ea3b59bc.svg";